import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';
import Image from 'gatsby-plugin-sanity-image';

import Card from '../Card';

import './CustomerQuote.scss';

const CustomerQuote = (props) => {
  const {
    children,
    className,
    authorName,
    authorJobTitle,
    authorCompanyName,
    showAuthorsCompany,
    authorThumbnail,
  } = props;

  return (
    <div
      className={classnames('CustomerQuotePancake', className)}
      key={authorName}
    >
      <Card paddingSize="Double" theme="Blue">
        <div className="CustomerQuotePancakeGrid">
          <div className="CustomerQuotePancakeAuthor">
            <Image
              {...authorThumbnail}
              width={72}
              height={72}
              alt={authorName}
              className="CustomerQuotePancakeAuthorThumbnail"
            />
            <div className="CustomerQuotePancakeAuthorName">{authorName}</div>
            <div className="CustomerQuotePancakeAuthorJobTitle">
              {authorJobTitle}
              {showAuthorsCompany && authorCompanyName
                ? `, ${authorCompanyName}`
                : ''}
            </div>
          </div>
          <div className="CustomerQuotePancakeText">{children}</div>
        </div>
      </Card>
    </div>
  );
};

export const query = graphql`
  fragment SanityPancakeCustomerQuote on SanityCustomerQuote {
    _key
    author {
      name
      jobtitle
      company {
        name
      }
      image {
        ...ImageWithPreview
      }
    }
    quote
    showAuthorsCompany
    _type
  }
`;

export default CustomerQuote;
